import LogManager from 'es/core/logging/LogManager';
const logger = LogManager.getLogger('app.security.AccessControlSet');

export default interface IAccessControlSet {
    [accessControl: string]: boolean;
}

export type AccessControlCollection = {
    [key: string]: string | AccessControlCollection;
};

export enum ChallengeType {
    /** The challenge can match any access control in a set */
    Any = 0,

    /** The challenge must match all access controls in a set */
    All = 1,
}

export const challenge = (
    accessControlSet: IAccessControlSet,
    challengeAccessControl: string | AccessControlCollection,
    challengeType = ChallengeType.Any
): boolean => {
    if (typeof challengeAccessControl === 'string') {
        if (!accessControlSet.hasOwnProperty(challengeAccessControl)) {
            logger.warn(
                `Access control '${challengeAccessControl}' not found in access control set - this access control is potentially invalid.`
            );
            return false;
        }

        return !!accessControlSet[challengeAccessControl];
    }

    const challengeKeys = Object.keys(challengeAccessControl);
    const challengeGrants = challengeKeys.filter(key => {
        const challengeAccessControlChild = challengeAccessControl[key];
        if (!challengeAccessControlChild) return false;
        return challenge(accessControlSet, challengeAccessControlChild);
    });

    const isSuccess =
        challengeType === ChallengeType.Any
            ? challengeGrants.length > 0
            : challengeGrants.length === challengeKeys.length;

    if (!isSuccess) {
        logger.warn(`Access denied: ${JSON.stringify(challengeAccessControl)}`);
    }

    return isSuccess;
};
